import React from "react";
import { Line, LineConfig } from "@ant-design/plots";

export default function LineChart() {
  const data = [
    { Date: "2025-11-15", Close: 980, Symbol: "AAPL" },
    { Date: "2025-11-16", Close: 99, Symbol: "AAPL" },
    { Date: "2025-11-17", Close: 1010, Symbol: "AAPL" },
    { Date: "2025-11-18", Close: 100, Symbol: "AAPL" },
    { Date: "2025-11-19", Close: 101, Symbol: "AAPL" },
    { Date: "2025-11-20", Close: 10, Symbol: "AAPL" },
    { Date: "2025-11-21", Close: 102, Symbol: "AAPL" },
    { Date: "2025-11-22", Close: 101, Symbol: "AAPL" },
    { Date: "2025-11-15", Close: 1, Symbol: "GOOG" },
    { Date: "2025-11-16", Close: 198, Symbol: "GOOG" },
    { Date: "2025-11-17", Close: 205, Symbol: "GOOG" },
    { Date: "2025-11-18", Close: 2029, Symbol: "GOOG" },
    { Date: "2025-11-19", Close: 28, Symbol: "GOOG" },
    { Date: "2025-11-20", Close: 200, Symbol: "GOOG" },
    { Date: "2025-11-21", Close: 210, Symbol: "GOOG" },
    { Date: "2025-11-22", Close: 220, Symbol: "GOOG" },
  ];

  const config: LineConfig = {
    data,
    xField: (d: any) => new Date(d.Date),
    yField: "Close",
    colorField: "Symbol",
    normalize: { basis: "first", groupBy: "color" },
    scale: {
      y: { type: "log" },
    },
    axis: {
      y: { title: "↑ Change in price (%)" },
    },
    label: {
      text: "Symbol",
      selector: "last",
      style: { fontSize: 10 },
    },
    tooltip: {
      channel: "y",
      valueFormatter: (val: number) => val.toFixed(1),
    },
    // One height for all four, so the cards line up in the grid.
    height: 320,
    // padding is the band between the components (the legend sits on top) and
    // the plot area — this is what sets the gap under the legend.
    paddingTop: 24,
  };

  return <Line {...config} />;
}
